import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton.vue';
import AppCategoriesHeader from '~/components/Layout/AppCategoriesHeader.vue';
import { useRecipeListingStore } from '~/composables/_next/stores/useRecipeListingStore';
import SearchFiltersOrganism from '~/components/_next/organisms/SearchFiltersOrganism.vue';
import AzSidebar from '~/components/_next/molecules/AzSidebar.vue';
import CardSkeleton from '~/assets/images/skeletons/card.svg?inline';
import { useSearchFacets } from '~/composables/_next/useSearchFacets';
import { useWait } from '~/composables/_next/useWait';
import { useSegment } from '~/composables/_next/useSegment';
import { useRecipesWishlists } from '~/composables/useRecipesWishlists';
import MobileFiltersButton from '~/components/ui/CustomStoreFrontUI/MobileFiltersButton.vue';
import BlockCategoryTagsGraphql from '~/components/Organisms/BlockCategoryTagsGraphql.vue';
import AzRichText from '~/components/_next/atoms/AzRichText.vue';
import AzRecipeCard from '~/components/_next/molecules/AzRecipeCard.vue';
import CategoryPageHeader from '~/components/Product/Category/CategoryPageHeader.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useUser } from '~/composables/_next/useUser';
import AzPagination from '~/components/_next/molecules/AzPagination.vue';
import { watchThrottled } from '@vueuse/core';
import { cacheControl } from '~/helpers/cacheControl';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
const __nuxt_page_meta = {
  middleware: [cacheControl('public, s-maxage=7200, stale-while-revalidate=3600, stale-if-error=3600') // 2 hours cache and 1 hour stale
      ],tracking: {
        category: TrackingPageCategory.RLP
      }
}
export default /*#__PURE__*/_defineComponent({
  ...__nuxt_page_meta,__name: 'LegacyRecipes',
  setup: function setup(__props) {
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR;
    var route = useRoute();
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n,
      app = _useNuxt2App.app,
      error = _useNuxt2App.error;
    var _useWait = useWait(),
      startWaiter = _useWait.startWaiter,
      endWaiter = _useWait.endWaiter,
      isWaiting = _useWait.isWaiting;
    var _useSlug = useSlug(),
      transformSlugsForSeo = _useSlug.transformSlugsForSeo;
    ;

    // TODO: Remove after Nuxt 3 migration
    onMounted(function () {
      var _useSegment = useSegment(),
        trackPage = _useSegment.trackPage;
      trackPage(PageTypes.RLP, TrackingPageCategory.RLP);
    });
    var _useSearchFacets = useSearchFacets(),
      facets = _useSearchFacets.facets,
      clearSearchFacets = _useSearchFacets.clearSearchFacets;
    var _useLegacySeoMeta = useLegacySeoMeta(),
      setMeta = _useLegacySeoMeta.setMeta;
    var _useRecipeListingStor = useRecipeListingStore(),
      fetchRecipeListing = _useRecipeListingStor.fetchRecipeListing,
      recipeListingFacets = _useRecipeListingStor.recipeListingFacets,
      recipeListingContent = _useRecipeListingStor.recipeListingContent,
      recipeListing = _useRecipeListingStor.recipeListing,
      fetchRecipeListingContent = _useRecipeListingStor.fetchRecipeListingContent,
      recipeListingPagination = _useRecipeListingStor.recipeListingPagination,
      recipeListingSort = _useRecipeListingStor.recipeListingSort,
      isStatic = _useRecipeListingStor.isStatic;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useLazyAsyncData = useLazyAsyncData("fetch-recipe-listing-".concat(route.params.slug), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _recipeListingContent, _recipeListingContent2;
        var seo;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!recipeListingContent.value || isStatic.value)) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return fetchRecipeListingContent();
            case 3:
              if (recipeListingContent.value) {
                _context.next = 6;
                break;
              }
              error({
                statusCode: 404
              });
              return _context.abrupt("return", true);
            case 6:
              seo = _objectSpread(_objectSpread({
                title: (_recipeListingContent = recipeListingContent.value) === null || _recipeListingContent === void 0 ? void 0 : _recipeListingContent.title
              }, (_recipeListingContent2 = recipeListingContent.value) === null || _recipeListingContent2 === void 0 ? void 0 : _recipeListingContent2.seo), {}, {
                slug: transformSlugsForSeo(recipeListingContent.value)
              });
              setMeta(seo);
              _context.next = 10;
              return fetchRecipeListing();
            case 10:
              if (!(recipeListingPagination.value && recipeListingPagination.value.current > recipeListingPagination.value.pages)) {
                _context.next = 13;
                break;
              }
              error({
                statusCode: 404
              });
              return _context.abrupt("return", true);
            case 13:
              return _context.abrupt("return", true);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))),
      loading = _useLazyAsyncData.pending,
      refresh = _useLazyAsyncData.refresh;
    watchThrottled(facets, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return refresh();
          case 2:
            window.scrollTo(0, 0);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), {
      throttle: 1000
    });
    watch(function () {
      var _route$query;
      return (_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.page;
    }, function (page, oldPage) {
      if (page !== oldPage) {
        window.scrollTo(0, 0);
      }
    }, {
      immediate: false
    });
    var parentCategory = computed(function () {
      var _recipeListingContent3, _recipeListingContent4, _recipeListingContent5, _recipeListingContent6, _recipeListingContent7, _recipeListingContent8;
      return recipeListingContent === null || recipeListingContent === void 0 ? void 0 : (_recipeListingContent3 = recipeListingContent.value) === null || _recipeListingContent3 === void 0 ? void 0 : (_recipeListingContent4 = _recipeListingContent3.linkedFrom) === null || _recipeListingContent4 === void 0 ? void 0 : (_recipeListingContent5 = _recipeListingContent4.itemTileCollection) === null || _recipeListingContent5 === void 0 ? void 0 : (_recipeListingContent6 = _recipeListingContent5.items[0]) === null || _recipeListingContent6 === void 0 ? void 0 : (_recipeListingContent7 = _recipeListingContent6.linkedFrom) === null || _recipeListingContent7 === void 0 ? void 0 : (_recipeListingContent8 = _recipeListingContent7.pageGenericCategoryCollection) === null || _recipeListingContent8 === void 0 ? void 0 : _recipeListingContent8.items[0];
    });
    var breadcrumbs = computed(function () {
      var _parentCategory$value, _parentCategory$value2, _recipeListingContent9, _recipeListingContent0;
      return [{
        link: app.localePath({
          name: 'index'
        }),
        text: i18n.t('utils.homeBreadcrumbs')
      }, {
        link: app.localePath("/category/".concat((_parentCategory$value = parentCategory.value) === null || _parentCategory$value === void 0 ? void 0 : _parentCategory$value.slug)),
        text: (_parentCategory$value2 = parentCategory.value) === null || _parentCategory$value2 === void 0 ? void 0 : _parentCategory$value2.title
      }, {
        link: app.localePath("/recipes/".concat((_recipeListingContent9 = recipeListingContent.value) === null || _recipeListingContent9 === void 0 ? void 0 : _recipeListingContent9.slug)),
        text: (_recipeListingContent0 = recipeListingContent.value) === null || _recipeListingContent0 === void 0 ? void 0 : _recipeListingContent0.title
      }].filter(function (breadcrumb) {
        return !breadcrumb.link.includes('undefined');
      });
    });
    var selectedSort = computed(function () {
      var _recipeListingSort$va, _recipeListingSort$va2, _recipeListingSort$va3;
      var currentSort = (_recipeListingSort$va = recipeListingSort.value) === null || _recipeListingSort$va === void 0 ? void 0 : _recipeListingSort$va.selected;
      var currentSortPosition = (_recipeListingSort$va2 = recipeListingSort.value) === null || _recipeListingSort$va2 === void 0 ? void 0 : (_recipeListingSort$va3 = _recipeListingSort$va2.options) === null || _recipeListingSort$va3 === void 0 ? void 0 : _recipeListingSort$va3.findIndex(function (sort) {
        return sort.id === currentSort;
      });
      return currentSortPosition !== 0 ? currentSort : undefined;
    });
    var sidebar = ref(null);
    /**
     * Opens the filters sidebar.
     */
    function openSidebar() {
      var _sidebar$value, _sidebar$value$sideba;
      (_sidebar$value = sidebar.value) === null || _sidebar$value === void 0 ? void 0 : (_sidebar$value$sideba = _sidebar$value.sidebar) === null || _sidebar$value$sideba === void 0 ? void 0 : _sidebar$value$sideba.showModal();
    }
    /**
     * Closes the filters sidebar.
     */
    function closeSidebar() {
      var _sidebar$value2, _sidebar$value2$sideb;
      (_sidebar$value2 = sidebar.value) === null || _sidebar$value2 === void 0 ? void 0 : (_sidebar$value2$sideb = _sidebar$value2.sidebar) === null || _sidebar$value2$sideb === void 0 ? void 0 : _sidebar$value2$sideb.close();
    }
    function onClearFilters() {
      return _onClearFilters.apply(this, arguments);
    }
    function _onClearFilters() {
      _onClearFilters = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return clearSearchFacets();
            case 2:
              closeSidebar();
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _onClearFilters.apply(this, arguments);
    }
    var _useAuthenticatedActi = useAuthenticatedAction(),
      doActionOrLogin = _useAuthenticatedActi.doActionOrLogin,
      navigateToOrLogin = _useAuthenticatedActi.navigateToOrLogin;
    var _useUiState = useUiState(),
      toggleAddRecipeToWishlistSidebar = _useUiState.toggleAddRecipeToWishlistSidebar;
    var _useRecipesWishlists = useRecipesWishlists(),
      isInRecipesWishlists = _useRecipesWishlists.isInRecipesWishlists,
      removeRecipeFromWishlist = _useRecipesWishlists.removeRecipeFromWishlist;
    function updateRecipeWishlist(recipe) {
      if (isAuthenticated.value) {
        var wishlisted = isInRecipesWishlists(recipe.recipeId);
        if (wishlisted) {
          removeRecipeFromWishlist(recipe.recipeId);
        } else {
          toggleAddRecipeToWishlistSidebar({
            contentfulId: recipe.recipeId,
            image: recipe.photo,
            name: recipe.title
          });
        }
      } else {
        navigateToOrLogin({
          nextRoutePath: route.path,
          previousRoutePath: route.path
        });
      }
    }
    var itemCount = computed(function () {
      var _recipeListingPaginat, _recipeListingPaginat2;
      return (_recipeListingPaginat = (_recipeListingPaginat2 = recipeListingPagination.value) === null || _recipeListingPaginat2 === void 0 ? void 0 : _recipeListingPaginat2.count) !== null && _recipeListingPaginat !== void 0 ? _recipeListingPaginat : 0;
    });
    function changeSort(_x) {
      return _changeSort.apply(this, arguments);
    }
    function _changeSort() {
      _changeSort = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(sort) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              startWaiter('sort.change');
              _context4.next = 3;
              return fetchRecipeListing(sort);
            case 3:
              endWaiter('sort.change');
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _changeSort.apply(this, arguments);
    }
    var filteredParamNames = computed(function () {
      var _recipeListingFacets$, _recipeListingFacets$2, _recipeListingFacets$3, _recipeListingFacets$4;
      // get all query parameters that can be set from facets
      var facetAttrs = (_recipeListingFacets$ = (_recipeListingFacets$2 = recipeListingFacets.value) === null || _recipeListingFacets$2 === void 0 ? void 0 : (_recipeListingFacets$3 = _recipeListingFacets$2.flatMap(function (facet) {
        return facet.subfacets || facet;
      })) === null || _recipeListingFacets$3 === void 0 ? void 0 : (_recipeListingFacets$4 = _recipeListingFacets$3.map(function (option) {
        return option.id;
      })) === null || _recipeListingFacets$4 === void 0 ? void 0 : _recipeListingFacets$4.filter(Boolean)) !== null && _recipeListingFacets$ !== void 0 ? _recipeListingFacets$ : [];
      return ['min-price', 'max-price'].concat(_toConsumableArray(new Set(facetAttrs)));
    });
    onMounted(function () {
      setDynamicYieldContext('OTHER', ['Recipe_Listing_Page']);
    });
    setDynamicYieldContextSSR('OTHER', ['Recipe_Listing_Page']);
    return {
      __sfc: true,
      setDynamicYieldContext: setDynamicYieldContext,
      setDynamicYieldContextSSR: setDynamicYieldContextSSR,
      route: route,
      isAuthenticated: isAuthenticated,
      i18n: i18n,
      app: app,
      error: error,
      startWaiter: startWaiter,
      endWaiter: endWaiter,
      isWaiting: isWaiting,
      transformSlugsForSeo: transformSlugsForSeo,
      facets: facets,
      clearSearchFacets: clearSearchFacets,
      setMeta: setMeta,
      fetchRecipeListing: fetchRecipeListing,
      recipeListingFacets: recipeListingFacets,
      recipeListingContent: recipeListingContent,
      recipeListing: recipeListing,
      fetchRecipeListingContent: fetchRecipeListingContent,
      recipeListingPagination: recipeListingPagination,
      recipeListingSort: recipeListingSort,
      isStatic: isStatic,
      isMobile: isMobile,
      loading: loading,
      refresh: refresh,
      parentCategory: parentCategory,
      breadcrumbs: breadcrumbs,
      selectedSort: selectedSort,
      sidebar: sidebar,
      openSidebar: openSidebar,
      closeSidebar: closeSidebar,
      onClearFilters: onClearFilters,
      doActionOrLogin: doActionOrLogin,
      navigateToOrLogin: navigateToOrLogin,
      toggleAddRecipeToWishlistSidebar: toggleAddRecipeToWishlistSidebar,
      isInRecipesWishlists: isInRecipesWishlists,
      removeRecipeFromWishlist: removeRecipeFromWishlist,
      updateRecipeWishlist: updateRecipeWishlist,
      itemCount: itemCount,
      changeSort: changeSort,
      filteredParamNames: filteredParamNames,
      AzBackToTopButton: AzBackToTopButton,
      AppCategoriesHeader: AppCategoriesHeader,
      SearchFiltersOrganism: SearchFiltersOrganism,
      AzSidebar: AzSidebar,
      CardSkeleton: CardSkeleton,
      MobileFiltersButton: MobileFiltersButton,
      BlockCategoryTagsGraphql: BlockCategoryTagsGraphql,
      AzRichText: AzRichText,
      AzRecipeCard: AzRecipeCard,
      CategoryPageHeader: CategoryPageHeader,
      AzButton: AzButton,
      AzIcon: AzIcon,
      AzPagination: AzPagination
    };
  }
});